export const FIND_CARE_PROVIDERS_FAILURE = 'FIND_CARE_PROVIDERS_FAILURE';

export const findCareProvidersFailure = ({ error, request }) => ({
    type: FIND_CARE_PROVIDERS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});